<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <div class="d-flex flex-wrap sheet-opciones-grupo" role="group">
      <button type="button" class="btn btn-sheet-opcion mb-1"
              :class="[valor === valorSi ? 'btn-success' : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="marcar(valorSi)">{{ etiquetaSi }}</button>
      <button type="button" class="btn btn-sheet-opcion mb-1"
              :class="[valor === valorNo ? 'btn-danger' : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="marcar(valorNo)">{{ etiquetaNo }}</button>
      <button type="button" class="btn btn-sheet-opcion mb-1"
              :class="[valor === valorNoAplica ? 'btn-secondary' : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="marcar(valorNoAplica)">{{ etiquetaNoAplica }}</button>
    </div>
    <slot name="dependiente"></slot>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/**
 * Pregunta SI / NO / NO APLICA con colores semánticos (verde / rojo / gris).
 * Persiste el literal de cada opción, igual que en el PDF y en la base de datos.
 */
export default {
  name: "QSiNoNoAplica",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    valorSi: { type: String, default: "SI" },
    valorNo: { type: String, default: "NO" },
    valorNoAplica: { type: String, default: "NO APLICA" },
    etiquetaSi: { type: String, default: "SI" },
    etiquetaNo: { type: String, default: "NO" },
    etiquetaNoAplica: { type: String, default: "NO APLICA" },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  computed: {
    valor() {
      return this.value;
    },
    respondida() {
      return this.valor === this.valorSi || this.valor === this.valorNo || this.valor === this.valorNoAplica;
    },
  },
  methods: {
    marcar(v) {
      if (this.soloLectura) return;
      const nuevo = this.value === v ? null : v;
      this.$emit("input", nuevo);
      this.$emit("cambio", nuevo);
    },
  },
};
</script>

<style scoped>
.btn.btn-sheet-opcion.btn-secondary {
  background-color: #e4e6ef;
  border-color: #e4e6ef;
  color: #3f4254;
}
</style>
